import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { CategoryEmitterModel } from "src/app/Models/categoryEmitter.model";
import { SearchPageService } from "src/app/views/searchpage/searchpage.service";
declare var $: any;
@Component({
  selector: "app-categorybar",
  templateUrl: "./categorybar.component.html",
  styleUrls: ["./categorybar.component.css"],
})

export class CategorybarComponent implements OnInit {
  @Input() isSalesCode: boolean;
  @Output() emitValues = new EventEmitter<CategoryEmitterModel>();

  public filterList = [
    {
      name: "Tags",
      value: "FileInfo.Tags",
    },
    {
      name: "Region",
      value: "FileInfo.Region",
    },
    {
      name: "Geography",
      value: "FileInfo.Geography",
    },
    {
      name: "Content",
      value: "Attachment.Content",
    },
    {
      name: "Project Manager",
      value: "FileInfo.ProjectManager",
    },
    {
      name: "Project Name",
      value: "FileInfo.ProjectName",
    },
    {
      name: "Sales Contact",
      value: "FileInfo.BdContact",
    },
    {
      name: "Client",
      value: "FileInfo.Client",
    },
    {
      name: "Vertical",
      value: "FileInfo.Vertical",
    },
    {
      name: "Project Status",
      value: "FileInfo.ProjectStatus",
    },
    {
      name: "Delivery Organization",
      value: "FileInfo.DeliveryOrganization",
    },
  ];

  public groupByList = [
    {
      name: "Region",
      value: "FileInfo.Region.keyword",
    },
    {
      name: "Geography",
      value: "FileInfo.Geography.keyword",
    },
    {
      name: "Project Manager",
      value: "FileInfo.ProjectManager.keyword",
    },
    {
      name: "Sales Contact",
      value: "FileInfo.BdContact.keyword",
    },
    {
      name: "Client",
      value: "FileInfo.Client.keyword",
    },
    {
      name: "Vertical",
      value: "FileInfo.Vertical.keyword",
    },
    {
      name: "Project Size",
      value: "FileInfo.ProjectSize.keyword",
    },
    {
      name: "Project Status",
      value: "FileInfo.ProjectStatus.keyword",
    },
    {
      name: "Delivery Organization",
      value: "FileInfo.DeliveryOrganization.keyword",
    },
  ];
  public groupBy = null;
  public selectedFiltersFlag = true;
  public validationFlag = false;
  public filter = new CategoryEmitterModel();

  constructor(private searchPageService: SearchPageService) {
    this.filter.groupBy = this.groupBy;
    this.filter.displayType = "card";
    if (
      this.searchPageService.searchOptions &&
      this.searchPageService.searchOptions.searchTerm !== "" &&
      this.searchPageService.searchOptions.searchTerm !== undefined
    ) {
      ;
      this.filter.groupBy = this.searchPageService.searchOptions.groupBy;
      this.filter.displayType =
        this.searchPageService.searchOptions.displayType;
      this.filter.operator = this.searchPageService.searchOptions.operator;
      this.filter.activeProjects =
        this.searchPageService.searchOptions.activeProjectsFilter;
      this.filter.filteredList =
        this.searchPageService.searchOptions.filterList;
    }
  }

  ngOnInit() {
    if (!this.isSalesCode) {
      this.groupByList = [
        {
          name: "Service Line",
          value: "ServiceLine",
        },
        {
          name: "Domain",
          value: "Domain",
        },
        {
          name: "Location",
          value: "Location",
        },
        {
          name: "Proposal Status",
          value: "ProposalStatus",
        },
        {
          name: "Size",
          value: "Size",
        },
        {
          name: "Delivery Methodology",
          value: "DeliveryMethod",
        },
        {
          name: "Service Offering",
          value: "ServiceOffering",
        },
        {
          name: "Tech Stack",
          value: "TechStack",
        },
        {
          name: "Primary Prospect",
          value: "PrimaryProspect",
        },
      ];
    }
    this.pushSelectedFiltersToForm();

    this.emitValues.emit(this.filter);
  }

  dismissRightSidebar() {
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }

  addFilterToList(value: string) {
    if (this.filter.filteredList.length > 0) {
      this.validationFlag = false;
    }
    if (this.isSalesCode) {
      if (!this.filter.filteredList.includes(value)) {
        this.filter.filteredList.push(value);
        this.validationFlag = false;
      } else {
        var index = this.filter.filteredList.indexOf(value);
        this.filter.filteredList.splice(index, 1);
        this.selectedFiltersFlag = false;
        if (this.filter.filteredList.length > 0) {
          this.validationFlag = false;
        } else {
          this.validationFlag = true;
        }
      }
    }
  }

  showValue() {
    this.filter.groupBy = null;
  }

  selectAllFilters() {
    this.selectedFiltersFlag = !this.selectedFiltersFlag;
    this.filter.filteredList = [];

    if (this.selectedFiltersFlag) {
      this.pushSelectedFiltersToForm();
    }
    this.validationForFilters();
  }

  pushSelectedFiltersToForm() {
    const filteredValues = new Array<string>();
    this.filterList.forEach((filter) => {
      filteredValues.push(filter.value);
    });

    this.filter.filteredList = filteredValues;
    this.validationForFilters();

  }

  updateDisplayType(value) {
    this.filter.displayType = value;
    this.dismissRightSidebar();
  }

  selectAllTokens() {
    this.filter.operator = !this.filter.operator;
  }

  selectActiveProjects() {
    this.filter.activeProjects = !this.filter.activeProjects;
  }
  stopPropagation(event: MouseEvent) {
    if (!this.isSalesCode) event.stopPropagation();
  }

  emitFilters() {
    if (this.filter.filteredList.length > 0) {
      this.emitValues.emit(this.filter);
      this.dismissRightSidebar();
    }
  }

  validationForFilters() {
    var returnStateForButton: boolean;
    if (this.filter.filteredList.length <= 0) {
      this.validationFlag = true;
      returnStateForButton = true;
    } else {
      this.validationFlag = false;
    }
    return returnStateForButton;
  }
}
